import React from 'react';
import EmailSignupForm from '../EmailSignupForm';
import '../../pages/LandingPage.css';
import SectionBackground from './SectionBackground';

const FinalCTASection: React.FC = () => {
  const handleSignupSuccess = () => {
    // Success handling is done by the EmailSignupForm component
  };

  return (
    <SectionBackground style={{
      padding: '100px 20px',
      background: 'linear-gradient(135deg, #0066FF 0%, #0052CC 100%)',
      color: 'white',
      textAlign: 'center',
    }}>
      <div className="container" style={{ maxWidth: '800px' }}>
        <h2 style={{ fontSize: '3rem', marginBottom: '30px', fontWeight: 700 }}>
          Stop Overpaying for California Leases
        </h2>
        <p style={{ fontSize: '1.5rem', marginBottom: '40px', opacity: 0.9 }}>
          Join California landlords who are saving money and drafting leases with California-focused guidance
        </p>
        <EmailSignupForm 
          formLocation="final-cta" 
          onSuccess={handleSignupSuccess} 
          customClass="email-form" 
          inputClass="email-input" 
          buttonClass="submit-btn"
          buttonText="Let's Get Started"
          isSignupButton={true}
        />
        <p style={{ marginTop: '20px', fontSize: '1.1rem', opacity: 0.8 }}>
          🎯 Limited spots available • 💳 No credit card required • 🚀 Launching Q3 2025
        </p>
      </div>
    </SectionBackground>
  );
};

export default FinalCTASection; 
